import { CommodityType } from "../../../Generated/Mark-It-View-Api";
import { EnumHelper } from "../../../Helpers";
import { RootState, useApplicationSelector } from "../../../Redux/ReduxStore";
import { CompanyProductAccessEntryModel } from "../../../Generated/Mark-It-View-Api";
import { StoneXSelect } from "../../StoneXMui";

interface MarkItViewCommodityTypeSelectorProps {
  value?: CommodityType | null;
  error?: string;
  onChange?: (commodityType: CommodityType | null) => void;
}

export default function MarkItViewCommodityTypeSelector(props: MarkItViewCommodityTypeSelectorProps) {
  const { value, error, onChange } = props;
  const productAccess = useApplicationSelector((state: RootState) => state.userAccess.productAccess);

  const options = getFilteredCommodityTypes(productAccess);

  return (
    <StoneXSelect
      options={options}
      getId={(x) => x}
      value={value ?? null}
      label="Commodity Types"
      error={error}
      onChange={onChange ?? (() => {})}
      getOptionLabel={(x) => EnumHelper.enumToString(x)}
    />
  );
}

function getFilteredCommodityTypes(productAccess: CompanyProductAccessEntryModel[]): CommodityType[] {
  let types = Object.values(CommodityType) as CommodityType[];

  if (productAccess.length > 0) {
    const allowedTypes = productAccess
      .map((entry: CompanyProductAccessEntryModel) => entry.commodityType)
      .filter((commodityType): commodityType is CommodityType => commodityType != null)
      .filter((value, index, self) => self.indexOf(value) === index);

    types = types.filter((q) => q === CommodityType.Favorites || allowedTypes.includes(q as any));
  }

  types.sort((a, b) => {
    if (a === CommodityType.Favorites) return -1;
    if (b === CommodityType.Favorites) return 1;
    return a < b ? -1 : a > b ? 1 : 0;
  });

  return types;
}
